import { render, staticRenderFns } from "./fball_icons.vue?vue&type=template&id=384faae0&scoped=true"
import script from "./fball_icons.vue?vue&type=script&lang=js"
export * from "./fball_icons.vue?vue&type=script&lang=js"
import style0 from "./fball_icons.vue?vue&type=style&index=0&id=384faae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384faae0",
  null
  
)

export default component.exports